import { Container, Row, Col } from "react-bootstrap"
import { Link } from "react-router-dom"
import "../components/styles/Footer.css"
import footerlogo from "../assets/productsec/footerlogo.jpeg";
function Footer() {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="footer-main">
          <Col lg={3} md={6} className="footer-info mb-4">
            <div className="footer-logo mb-3">
            <div className="footer-logo mb-3 position-relative">
  <p 
    style={{
      fontSize: '30px',
      borderRadius: '50%',
      height: '30px',
      width: '30px',
      position: 'absolute',
      top: '12%', 
      right: '-0.1%',
      left:'57%',
      transform: 'translate(50%, -50%)',
  
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign:'center',
      color:'black'
    }} 
    className="rsymbol"
  >
    ®
  </p>
  <img src={footerlogo} alt="SunShiny" className="img-fluid" />
</div>

            </div>
            <p className="company-description">Schoon Housekeeping Solutions </p>
            <div className="social-links">
            <Link to="https://www.facebook.com/profile.php?id=61558188570189#" target="_blank" className="social-icon">
    <i className="bi bi-facebook"></i>
  </Link>    <Link to="https://www.instagram.com/sunshinyenterprises/"  target="_blank" className="social-icon">
    <i className="bi bi-instagram"></i>
  </Link>
  <Link to="https://www.linkedin.com/in/sun-shiny-enterprises-schoon-862a78278/"  target="_blank" className="social-icon">
    <i className="bi bi-linkedin"></i>
  </Link>
            </div>
          </Col>

          <Col lg={3} md={6} className="footer-links mb-4">
            <h4>QUICK LINKS</h4>
            <ul className="footer-nav">
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/services">Our Services</Link>
              </li>
              <li>
                <Link to="/partner">Partner Support</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </Col>

          <Col lg={3} md={6} className="footer-services mb-4">
            <h4>SERVICES</h4>
            <ul className="footer-nav">
              <li>
                <Link to="/sales">Regular Maintenance</Link>
              </li>
              <li>
                <Link to="/software">Deep Cleaning</Link>
              </li>
              <li>
                <Link to="/network">Healthcare Facilities</Link>
              </li>
              <li>
                <Link to="/surveillance">Manufacturing Facilities</Link>
              </li>
              <li>
                <Link to="/wireless">Warehouse Cleaning</Link>
              </li>
              <li>
                <Link to="/consulting">Equipment Maintenance</Link>
              </li>
              <li>
                <Link to="/managed">Specialized Cleaning Services</Link>
              </li>
              <li>
                <Link to="/telecom">Window Services</Link>
              </li>
            </ul>
          </Col>

          <Col lg={3} md={6} className="footer-contact mb-4">
            <h4>REACH US</h4>
            <p>
              <i className="bi bi-telephone-fill"></i> +91 86085 98089 | +91 87544 72227
            </p>
            <p>
              <i className="bi bi-envelope-fill"></i>  info@sunshiny.co.in | sales@sunshiny.co.in
            </p>
            <p>
              <i className="bi bi-geo-alt-fill"></i> No.62A, Thiruvalluvar St, Jagathambigai Nagar, Padi, Chennai-600
              050
            </p>
          </Col>
        </Row>

        <Row className="footer-bottom">
          <Col md={6}>
            <p className="copyright">Copyright © 2023 SunShiny Private Limited</p>
          </Col>
          <Col md={6} className="text-md-end">
            <p className="designer">Design by Ricehr</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer

